import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { AppSmallTabs } from "../../Generic/AppSmallTabs";
import { TrainingCenterTab } from "../MainTypes";

const activeTabMap: { [tab in TrainingCenterTab]: number } = {
  Required: 0,
  Completed: 1,
};

interface Props {
  activeTab: TrainingCenterTab;
  onClick: (tab: TrainingCenterTab) => void;
}

const TrainingCenterTabs = (props: Props) => {
  const handleClick = React.useCallback(
    (tabIndex: number) => {
      switch (tabIndex) {
        case activeTabMap.Required:
          return props.onClick.call(null, "Required");
        case activeTabMap.Completed:
          return props.onClick.call(null, "Completed");
        default:
          throw new Error(`unknown tabIndex ${tabIndex}`);
      }
    },
    [props.onClick]
  );

  return (
    <AppSmallTabs
      activeTab={activeTabMap[props.activeTab]}
      tabs={[translate(STRINGS.REQUIRED), translate(STRINGS.COMPLETED)]}
      onClick={handleClick}
    />
  );
};

export default React.memo(TrainingCenterTabs);
